import { render, staticRenderFns } from "./news_detail.vue?vue&type=template&id=5b787824&scoped=true&"
import script from "./news_detail.vue?vue&type=script&lang=js&"
export * from "./news_detail.vue?vue&type=script&lang=js&"
import style0 from "./news_detail.vue?vue&type=style&index=0&id=5b787824&lang=scss&scoped=true&"
import style1 from "./news_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b787824",
  null
  
)

export default component.exports